import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DivWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

export const Div = styled.div`
    margin: 10px;
    height: calc(100% - 24px);
    opacity: ${(props) => (props.canvasIsEmpty ? '0.25' : '1')};
`;

export const Text = styled.p`
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 2px 4px;
    color: black;
`;

export const HelperText = styled.p`
    font-size: 16px;
    padding: 40px 20px;
    text-align: left;
    color: gray;
    line-height: 70px;
    font-style: italic;
`;

export const InnerDiv = styled.div`
    width: 100%;
    height: 100%;
    padding-top: 10px;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const Paragraph = styled.p`
    font-size: 10px;
    font-style: italic;
    position: absolute;
    bottom: 16px;
    left: 24px;
    width: 100%;
`;

export const MoveIcon = styled.i`
    font-size: 14px;
    margin-right: 4px;
    color: ${({ disabled, theme }) => (disabled ? theme.colors.neutral100 : theme.colors.neutral900)};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    &:hover {
        ${({ disabled, theme }) => (disabled ? '' : `color: ${theme.colors.primary300}`)};
    }
`;

export const DeleteIcon = styled.i`
    font-size: 14px;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    color: ${({ disabled, theme }) => (disabled ? theme.colors.neutral100 : theme.colors.neutral900)}
    ${({ disabled, theme }) => (disabled ?
        null :
        `&:hover {
            color: ${theme.colors.danger300};
        }`
    )}
`;

export const ActiveIconHeader = styled.div`
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.83px;
    color: ${({ theme }) => theme.colors.neutral900};
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
    padding-right: 15px;
`;

const keyFrames = (direction) => keyframes`
    from {
        ${direction}: 61px;
    }
    to {
        ${direction}: 0;
    }
`;

export const ActiveIconWrapper = styled.div`
    width: 180px;
    position: relative;
    transition: top 200ms ease-out;
    animation: ${({ animate, direction }) => (animate ? keyFrames(direction) : null)} 200ms ease-out;
`;

export const Info = styled.div`
    width: 171px;
    display: inline-flex;
    color: ${({ theme }) => theme.colors.neutral900};
    vertical-align: middle;
    line-height: 9px;
    font-size: 11px;
    font-weight: 600;
`;


export const Icon = styled.i`
    font-size: 11px;
    color: ${({ theme }) => theme.colors.primary300};
    margin-left: 4px;
    vertical-align: middle;
`;

export const SourceEditorBody = styled.div`
    color: rgb(28, 28, 28);
    font-size: 12px;
    font-weight: 600;
    height: 13px;
    letter-spacing: 1;
`;

export const ModalHeader = styled.div`
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
`;

export const InfoBlock = styled.div`
    background: rgb(255, 255, 255);
    border-radius: 0px;
    box-shadow: 0px 0px 4px 0px rgba(28, 28, 28, 0.2);
    height: 202px;
    width: 231px;
    position: absolute;
    margin-left: 500px;
    margin-top: 13px;
    padding: 23px 17px;
`;

export const InfoHeader = styled.div`
    color: rgb(24, 128, 72);
    font-size: 11px;
    font-weight: 600;
    height: 6px;
    line-height: 6px;
    text-transform: uppercase;
    width: 184px;
`;

export const InfoIcon = styled(FontAwesomeIcon)`
    float: right;
    color: rgb(2, 119, 189);
    border-radius: 0;
    height: 42px;
    width: 20px;
    font-size: 20px;
`;

export const SourceEditor = styled.textarea`
    padding: 24px;
    background-color: #1c1c1c;
    color: white;
    font-size: 12px;
    font-weight: 600;
    height: 352px;
    letter-spacing: 1;
    margin-top: 34px;
    margin-bottom: 24px;
    resize: none;
`;

export const InfoBody = styled.div`
    margin-top: 10px;
`;

export const SecondaryHeader = styled.div`
    height: 18px;
    margin-top: 20px;
`;

export const ModalButtons = styled.div`
    width: 519px;
    justify-content: flex-end;
    display: flex;
`;

export const AllowCommentsDiv = styled.div`
    display: flex;
    align-items: center;
    width: 180px;
    margin: 5px 0 18px 0;
`;

export const CloseButtonWrapper = styled.div`
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
`;

export const CloseIcon = styled(FontAwesomeIcon)`
    margin: 7px 12px;
    font-size: 18px;
`;

export const AllowCommentsText = styled.div`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 12px;
    font-weight: 600;
    margin-right: 10px;
    margin-top:2px;
`;

export const LinkTipDiv = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-bottom: 18px;
`;

export const LinkIcon = styled(FontAwesomeIcon)`
    font-size: 11px;
    color: ${({ theme }) => theme.colors.primary300};
    margin: 0 4px 0 4px;
    vertical-align: middle;
`;

export const Link = styled.a`
    font-size: 11px;
    line-height: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.primary300};
    text-decoration: none;
    &:hover {
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.primary700};
    }
`;

export const Label = styled.span`
    width: 100%;
    font-weight: 700;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin: 8px 0;
    color: ${({ theme }) => theme.colors.neutral700};
`;

export const SmallLabel = styled.label`
    color: ${({ theme }) => theme.colors.neutral700};
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 1px;
    cursor: pointer;

    &::first-letter {
        text-transform: uppercase;
    }
`;
